import React from 'react';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/DeleteOutline';
import DetailsIcon from '@material-ui/icons/ListAlt';
import styled from 'styled-components';

const Actions = ({ onEdit, onDelete, onDetails, row, showDelete }) => (
  <Wrapper>
    {onEdit && (
      <IconBtn type="button" title="Edit" onClick={() => onEdit(row)}>
        <EditIcon style={{ fontSize: 18 }} />
      </IconBtn>
    )}
    {showDelete && onDelete && (
      <IconBtn type="button" title="Delete" $danger onClick={() => onDelete(row)}>
        <DeleteIcon style={{ fontSize: 18 }} />
      </IconBtn>
    )}
    {onDetails && (
      <IconBtn type="button" title="Configure form" onClick={() => onDetails(row)}>
        <DetailsIcon style={{ fontSize: 18 }} />
      </IconBtn>
    )}
  </Wrapper>
);

export default Actions;

const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 6px;
  padding: 12px;
`;

const IconBtn = styled.button<{ $danger?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  flex: 0 0 auto;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--neutral-0);
  color: var(--neutral-600);
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: ${({ $danger }) => ($danger ? 'var(--danger-50, #fdecea)' : 'var(--primary-50)')};
    border-color: ${({ $danger }) => ($danger ? 'var(--danger-500, #d44b3f)' : 'var(--primary-600)')};
    color: ${({ $danger }) => ($danger ? 'var(--danger-500, #d44b3f)' : 'var(--primary-700)')};
  }

  &:focus-visible {
    outline: none;
    box-shadow: var(--shadow-focus);
  }
`;
